const MAX_SAME_ERROR_PER_SESSION = 5;

const errorCounts = new Map<string, number>();

function fingerprintOf(event: { exception?: { values?: { type?: string; value?: string }[] }; message?: string }): string {
  const exc = event.exception?.values?.[0];
  if (exc) {
    return `${exc.type ?? ''}:${exc.value ?? ''}`;
  }
  return event.message ?? 'unknown';
}

// A single stuck retry loop in one tab can throw the same error hundreds of
// times, blowing through the org's monthly Sentry event quota on its own.
// sampleRate alone doesn't help here — it's a flat probability applied
// independently per event, not aware that this is the 400th occurrence of
// the same error. This counts occurrences per fingerprint for the lifetime
// of the page and drops the rest once the budget is spent.
export function isRepeatedErrorOverBudget(event: { exception?: { values?: { type?: string; value?: string }[] }; message?: string }): boolean {
  const key = fingerprintOf(event);
  const count = (errorCounts.get(key) ?? 0) + 1;
  errorCounts.set(key, count);
  return count > MAX_SAME_ERROR_PER_SESSION;
}
